import { render } from "./key-value-input.vue?vue&type=template&id=d2243c0e"
import script from "./key-value-input.vue?vue&type=script&setup=true&lang=js"
export * from "./key-value-input.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/components/form/key-value-input.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d2243c0e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d2243c0e', __exports__)) {
    console.log('reload')
    api.reload('d2243c0e', __exports__)
  }
  
  module.hot.accept("./key-value-input.vue?vue&type=template&id=d2243c0e", () => {
    console.log('re-render')
    api.rerender('d2243c0e', render)
  })

}


export default __exports__